<!-- 
Dialog showing exception counts for each month.
-->
<template>
  <v-dialog :value="show" persistent content-class="dialog md">
    <exception-counts-by-month-chart v-if="show" @click="hide">
      <v-card-actions>
        <v-spacer/>
        <v-btn flat @click.prevent="hide">Close</v-btn>
      </v-card-actions>
    </exception-counts-by-month-chart>
  </v-dialog>
</template>

<script>
import ExceptionCountsByMonthChart from "@/components/exception-logs/ExceptionCountsByMonthChart.vue";

export default {
  components: {
    ExceptionCountsByMonthChart
  },
  model: {
    prop: "show",
    event: "update:show"
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    hide() {
      this.$emit("update:show", false);
    }
  }
};
</script>
